import React, { useEffect, useState } from "react";
import { Input, Divider, Spin, Select } from "antd";
import CustomButton from "../../../../common/custom-button/custom-button";
import CustomTable from "../../../../common/custom-table/custom-table";
import styles from "./formlist.module.css";
import {
  getEcdClasses,
  getFormlistingData,
  publishAllEcdReport,
  publishAllReportCardResult,
} from "../../../../services/reportCard";
import { toast } from "react-toastify";
import CustomSelect from "../../../../common/input/custom-select/custom-select";

const { Option } = Select;

const FormList = ({ 
  exam, 
  onViewDetails, 
  onClick, 
  isECDProgram,
  selectedYear,
  termList,
  selectedTerm,
  setSelectedTerm,
}) => {
  const [searchText, setSearchText] = useState("");
  const [formData, setFormData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);
  const [isPublished, setIsPublished] = useState(1);

  useEffect(() => {
    if (!isECDProgram) {
      setIsPublished(exam?.raw?.is_published ? 1 : 0);
    }
  }, [exam]);

  const getFormListData = async () => {
    if (!exam?.id) return;
    setLoading(true);
    try {
      const response = await getFormlistingData({
        exam_id: exam.id,
        name: searchText,
      });
      const apiData = response?.data?.data || [];
      setFormData(apiData);
    } catch (error) {
      console.error("Failed to fetch form list:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchEcdClasses = async () => {
    setLoading(true);
    try {
      const params = {
        academic_year_id: selectedYear,
      };
      const response = await getEcdClasses(params);
      const apiData = response?.data?.data || [];
      setFormData(apiData);

      const allPublished = apiData?.every((cls) => cls?.is_allpublish);
      setIsPublished(allPublished ? 1 : 0);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isECDProgram) {
      setFormData([]);
      fetchEcdClasses();
    } else {
      getFormListData();
    }
  }, [exam?.id, searchText, isECDProgram]);

  const filteredData = formData.filter((item) =>
    item.level_name.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    {
      title: "Level",
      dataIndex: "level_name",
      sorter: (a, b) => a.level_name.localeCompare(b.level_name),
    },
    {
      title: "Classes",
      render: (record) =>
        record.sections?.map((s) => s.section_name).join(", "),
    },
    {
      title: "Total Students",
      dataIndex: "students_count",
      sorter: (a, b) => a.students_count - b.students_count,
    },
    {
      title: "Action",
      render: (_, record) => (
        <CustomButton
          title="View Details"
          onClick={() => onViewDetails(record)}
        />
      ),
    },
  ];

  const handlePublishAllResult = async () => {
    try {
      setIsPublishing(true);
      let response;
      if (isECDProgram) {
        response = await publishAllEcdReport({ term_id: selectedTerm });
        fetchEcdClasses();
      } else {
        response = await publishAllReportCardResult({ exam_id: exam.id });
        getFormListData();
      }
      toast.success(response?.data?.message || "All result has been published");
      setIsPublished(1);
    } catch (err) {
      console.log(err);
      toast.error(err?.data?.message || "Failed to publish all results");
    } finally {
      setIsPublishing(false);
    }
  };

  return (
    <div>
      {!isECDProgram ? (
        <span className={styles.backBtn} onClick={onClick}>
          &lt; Examination List
        </span>
      ) : null}

      <div className={styles.headerContainer}>
        <h3 className={styles.title}>List of Forms</h3>
        <div className={styles.headerRight}>
          <CustomButton
            title="Publish All"
            disabled={Boolean(isPublished)}
            onClick={handlePublishAllResult}
            loading={isPublishing}
            style={{ height: "32px" }}
          />
          <Input.Search
            placeholder="Search by level name"
            allowClear
            onChange={(e) => setSearchText(e.target.value)}
            className={styles.searchInput}
          />
          {isECDProgram ? (
            <CustomSelect
              placeholder="--Select--"
              value={selectedTerm}
              onChange={(value) => setSelectedTerm(value)}
              style={{ width: "120px" }}
            >
              {termList?.map((option) => (
                <Option key={option?.value} value={option?.value}>
                  {option?.label}
                </Option>
              ))}
            </CustomSelect>
          ) : null}
        </div>
      </div>

      <Divider className={styles.divider} />

      <Spin spinning={loading}>
        <CustomTable
          columns={columns}
          dataSource={filteredData}
          pagination={false}
          rowKey="level_id"
        />
      </Spin>
    </div>
  );
};

export default FormList;
